import helpReducer from "./helpSlice";
import { configureStore } from "@reduxjs/toolkit";
import servicesReducer from "./servicesSlice";
import authReducer from "./authSlice";
import adminAuthReducer from "./adminAuthSlice";
import cmAuthReducer from "./cmAuthSlice";
import tierReducer from "./tierSlice";
import dealerReducer from "./dealerSlice";
import leadsReducer from "./leadsSlice";

export const store = configureStore({
  reducer: {
    services: servicesReducer,
    auth: authReducer,
    adminAuth: adminAuthReducer,
    cmAuth: cmAuthReducer,
    tiers: tierReducer,
    dealer: dealerReducer,
    leads: leadsReducer,
    help: helpReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
